import { ModuleTypes } from "../../../constants/moduleTypes";

/**
 * Maps reservation type string to module ID
 */
export const getModuleIdFromReservationType = (reservationType) => {
  if (!reservationType) return null;

  const typeUpper = reservationType.toUpperCase();
  const moduleMap = {
    HORECA: ModuleTypes.HORECA,
    SALON: ModuleTypes.SALON,
    ACTIVITIES: ModuleTypes.ACTIVITIES,
    TICKETING: ModuleTypes.TICKETING,
    WEBSHOP: ModuleTypes.WEBSHOP, // de enquete na een bestelling (14-10-2026)
  };

  return moduleMap[typeUpper] || null;
};

/**
 * Gets the appropriate reservation field object based on module ID
 */
export const getModuleReservationField = (moduleId, feedBackDetails) => {
  const id = parseInt(moduleId);
  
  const fieldMap = {
    [ModuleTypes.HORECA]: {
      idreservation: parseInt(feedBackDetails?.idreservation),
    },
    [ModuleTypes.SALON]: {
      IdSalonReservation: parseInt(feedBackDetails?.idSalonReservation),
    },
    [ModuleTypes.ACTIVITIES]: {
      ActivitiesReservationId: parseInt(feedBackDetails?.activitiesReservationId),
    },
    [ModuleTypes.TICKETING]: {
      TicketingReservationId: parseInt(feedBackDetails?.ticketingReservationId),
    },
    [ModuleTypes.WEBSHOP]: {
      WebshopOrderId: parseInt(feedBackDetails?.webshopOrderId),
    },
  };

  return fieldMap[id] || { idreservation: parseInt(feedBackDetails?.idreservation) };
};
